import { FC } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useTranslation } from 'react-i18next';
import UtmsButton from '../ui/UtmsButton';
import { Box } from '@mui/material';

type ModalErrorProps = {
    object: string;
    action: string;
    open: boolean;
    errorInfo: any;
    handleClose: () => void;
    getErrorReasonFromErrorObj: (obj: any) => string;
};

const ModalError: FC<ModalErrorProps> = ({
    object,
    action,
    open,
    errorInfo,
    handleClose,
    getErrorReasonFromErrorObj,
}) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClick={(e) => e.stopPropagation()} PaperProps={{ sx: { maxHeight: 700, maxWidth: 700 } }}>
            <DialogTitle variant="h4">{t('error')}</DialogTitle>
            <DialogContent dividers>
                <Box sx={{ mb: 0 }}>{`${t('error_while')} ${action} ${object}:`}</Box>
                <Box sx={{ whiteSpace: 'pre-wrap' }}>{getErrorReasonFromErrorObj(errorInfo)}</Box>
            </DialogContent>
            <DialogActions>
                <UtmsButton onClick={handleClose} color="secondary">
                    {t('close')}
                </UtmsButton>
            </DialogActions>
        </Dialog>
    );
};

export default ModalError;
